import React, { Fragment } from 'react'
import Ad from '../../components/Ad'
import FORMATS from '../../components/AdFormats'
import ArticleCard from '../../components/ArticleCard'

const AuthorArticles = ({ articles, sectionLabel, section, noImage, isConnected, moreButton }) => {
  return (
    <>
      {articles.map((article, index) => {
        return (
          <Fragment key={article.contentKey}>
            <ArticleCard article={article} noImage={noImage} />
            {index === 11 && (
              <Ad isConnected={isConnected} path={`/${process.env.RAZZLE_DFP_CODE}/${section}`} slotId='leaderboard-2' targeting={{ leaderboard: '2' }} collapseEmptyDiv className='advert-leaderboard-2' {...FORMATS.leaderboard3} />
            )}
          </Fragment>
        )
      })}
      {moreButton}
    </>
  )
}

export default AuthorArticles
